import React from "react";
import { getLabelById } from "../../../app/utils/projectBoard/boardDesignTokens";
import { findCustomLabel } from "../../../app/utils/projectBoard/boardCustomLabels";
import "./BoardLabel.scss";

const BoardLabel = ({
  labelId,
  label,
  boardId,
  named = false,
  selectable = false,
  selected = false,
  onClick,
  className = "",
}) => {
  const data =
    label ||
    getLabelById(labelId) ||
    findCustomLabel(labelId, boardId);
  if (!data) return null;

  const classes = [
    "pb-label",
    `pb-label--${data.id}`,
    named ? "pb-label--named" : "",
    selectable ? "pb-label--selectable" : "",
    selected ? "pb-label--selected" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const Tag = onClick ? "button" : "span";

  return (
    <Tag
      type={onClick ? "button" : undefined}
      className={classes}
      onClick={onClick}
      title={data.name}
      aria-label={data.name}
      style={{ backgroundColor: data.color }}
    >
      {named ? data.name : null}
    </Tag>
  );
};

export default BoardLabel;
